<script>
export default {
  name: 'CargoSelect',
  components: {},
  props: {
    value: {
      type: [String, Array],
      default: null
    },
    manualTrigger: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      options: [],
      exclusionId: null
    };
  },
  computed: {
    selectedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  mounted() {
    if (this.manualTrigger) {
      this.$emit('mounted')
    } else {
      this.initOptions();
    }
  },
  methods: {
    initOptions() {
      this.loading = true;
      const queryParams = {
        exclusionId: this.exclusionId
      }
      this.$store.dispatch('bu_cargo/fetchOptions', queryParams).then(res => {
        this.options = res.data || [];
      }).finally(() => {
        this.loading = false;
      });
    },
    setExclusionId(val) {
      const needRefresh = val !== this.exclusionId
      this.exclusionId = val
      if (needRefresh) {
        this.initOptions()
      }
    },
    onChange(val) {
      if (Object.hasOwn(this.$attrs, 'multiple')) {
        const selectedItems = val.map(item => this.options.find(option => option.label === item));
        this.$emit('change', selectedItems);
      } else {
        const selectedItem = this.options.find(item => item.label === val);
        this.$emit('change', selectedItem);
      }
    }
  }
}
</script>

<template>
  <el-select
    v-model="selectedValue"
    :loading="loading"
    v-bind="$attrs"
    @change="onChange"
    filterable
    default-first-option
    clearable
    style="width: 100%;"
  >
    <el-option
      v-for="item in options"
      :key="item.label"
      :label="item.label"
      :value="item.label"
    >
    </el-option>
  </el-select>
</template>

<style scoped lang="scss">
</style>
